var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreesLandscaping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.47,76.89a37.5,37.5,0,0,1,14.88-3.07c21.11,0,38.23,17.48,38.23,39s-17.12,39-38.23,39a38.08,38.08,0,0,1-33.06-19.42M64.5,175h99m-32.13-60.47,15.28,12.9m1-10.57,13.14-12.63m-13.64,70.27V94.41m-16.09-.29c0,28.05-22.27,50.79-49.75,50.79S31.57,122.17,31.57,94.12,53.84,43.33,81.31,43.33c22,0,40.7,14.6,47.25,34.85A51.74,51.74,0,0,1,131.06,94.12ZM60.54,96.35l19.87,16.78M81.7,99.38,98.81,83M81.05,174.39V70.12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesLandscaping);
export default __webpack_public_path__ + "static/media/TREES_LANDSCAPING.1d6600ec872569f89784a2f58f2b7d15.svg";
export { ForwardRef as ReactComponent };